const schema = {
  title: 'Correspondant',
  type: 'object',
  properties: {
    // title: { 
    //   type: ['string', 'null'],
    //   format:'string',
    //   isNotEmpty: true,
    //   isNotNull: true,
    // },
    firstname: { 
      type: 'string',
      maxLength: 50,
      isNotEmpty: true
    },
    lastname: { 
      type: 'string',
      maxLength: 50,
      isNotEmpty: true
    },
    note: {
      type: 'string',
    },
    gender: {
      type: 'string',
      enum: ['male', 'female'],
      isNotEmpty: true,
    },
    mode_adresse: {
      type: 'string',
      enum: ['tu', 'vous'],
      isNotEmpty: true,
    }
  },
  required: ['firstname', 'lastname', 'gender', 'mode_adresse']
}

export default schema